import React, { useState, useEffect } from 'react';

export const AccessibleFocusOutline = (props) => {
  const modifierClasses = props.classes ?? '';
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [])

  const handleKeydown = (e) => { 
    const isTabEvent = e.keyCode === 9;

    if (isTabEvent) {
      setIsEnabled(true);
    }
  };

  return (
    <span className={`${modifierClasses} ${isEnabled ? '' : 'noOutlineOnFocus'}`}>
      {props.children}
    </span>
  )
}
